import 'es6-promise/auto'
import axios from 'axios'

const apiClient = axios.create({
    baseURL: `https://login.muzible.com/api/v1`,
    // ---------------
    //withCredentials: false, // This is the default
    headers: {
      'Access-Control-Allow-Origin' : '*',
    }
  })

export default {


}
